import { render, staticRenderFns } from "./VideoFileIcon.vue?vue&type=template&id=02af0652"
import script from "./VideoFileIcon.vue?vue&type=script&lang=js"
export * from "./VideoFileIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports